<template>
  <div class="search-form">
    <div class="side-frame-success">
      <b-row>
        <span
          style="font-size: 14px; color: #606266;display: flex;
    align-items: center;margin-left: 15px"
          >{{ $l('tab_title_moq_material_goods') || '物料关联产品' }}</span
        >
        <b-col cols="7">
          <b-form @reset="reset" onsubmit="return false">
            <b-input-group size="sm">
              <b-form-input
                @keyup.enter="query"
                type="search"
                v-model.trim="form.keyword"
                :placeholder="
                  '产品SKU编号/NC产品编号/产品企划名称/产品名称/产品颜色/品牌名称/SKU-新编号/内部编号 搜索...'
                "
              />
              <b-input-group-append>
                <b-button-group>
                  <b-button-group slot="reference">
                    <b-button
                      variant="link"
                      size="sm"
                      class="search-dropdown-button"
                      squared
                      @click="openAdvqueryDialog"
                    >
                      {{ $l('INDEX.advanced_search') || '高级搜索' }}
                    </b-button>
                    <b-button variant="primary" size="sm" @click="query">
                      <i class="fa fa-search" />
                    </b-button>
                  </b-button-group>
                </b-button-group>
              </b-input-group-append>
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="$emit('openChooseSkuDialog')"
                v-if="allow('A')"
                v-show="!disabled"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('INDEX.btn_add') || '新增' }}
              </b-button>
              <slot />
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1200px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'产品SKU编号'">
              <el-input
                v-model.trim="form.amzSkuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'NC产品编号'">
              <el-input
                v-model.trim="form.ncNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'产品名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'产品颜色'">
              <el-input
                v-model.trim="form.goodsColor"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'SKU-新编号'">
              <el-input
                v-model.trim="form.skuNoNew"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'内部编号'">
              <el-input
                v-model.trim="form.internalSkuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'主分类'">
              <dict-select
                v-model="form.listMasterCategoryCode"
                url="/master/masterCategory/select"
                :body="masterCategoryParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'企划人员'">
              <dict-select
                v-model="form.listDesignCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'采购人员'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
    }
  },
  mounted() {
    // this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
